import React from 'react';

export const ArrowLeft = ({ color = '#181818', ...restProps }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      {...restProps}
    >
      <path d="M19 12.1431H5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12 19.1431L5 12.1431L12 5.14307"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
